import { CURRENCIES } from "./constants";

export const getFormData = (formEl) => {
  return Array.from(formEl.querySelectorAll("input")).reduce((fd, input) => {
    fd.append(input.name, input.value);

    return fd;
  }, new FormData());
};

export const determineBestDPRange = (from, to, date) => {
  if (!from && !to) {
    return [date, null];
  } else if (from && !to) {
    return [from, date].sort((a, b) => a.unix() - b.unix());
  }

  return [date, null];
};

export const getBookingDateDisplay = (from, to) => {
  if (!moment.isMoment(from)) {
    return [];
  }

  if (!moment.isMoment(to)) {
    return [from.format("MMM DD, YYYY")];
  }

  if (from.year() !== to.year()) {
    return [from.format("MMM DD, YYYY"), to.format("MMM DD, YYYY")];
  }

  if (from.month() !== to.month()) {
    return [from.format("MMM DD"), to.format("MMM DD, YYYY")];
  }

  if (from.month === to.month) {
    return [from.format("MMM DD"), to.format("DD, YYYY")];
  }

  return [];
};

export const getLiveaboardMonthDisplay = (mm) => {
  if (moment(mm).isValid() === false) {
    return null;
  }

  return moment(mm).format("MMMM YYYY");
};

export const getBookingGuestsDisplay = (guests) => {
  if (guests === "0") {
    return "";
  }

  if (guests === "1") {
    return "1 guest";
  }

  return `${guests} guests`;
};

export const getDetailedBookingGuestsDisplay = (guests) => {
  const total = guests.divers + guests.studentDivers + guests.nonDivers;

  if (total === 0) {
    return "";
  }

  return `${total} guests`;
};

export const getBookingTravelersDisplay = (guests) => {
  if (guests === "0") {
    return "";
  }

  if (guests === "1") {
    return "1 traveler";
  }

  return `${guests} travelers`;
};

export const getBookingRoomsDisplay = (rooms) => {
  if (rooms === 0) {
    return "";
  }

  if (rooms === 1) {
    return "1 room";
  }

  return `${rooms} rooms`;
};

export const getQueryStringValue = (key) =>
  decodeURIComponent(
    window.location.search.replace(
      new RegExp(
        "^(?:.*[&\\?]" +
          encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") +
          "(?:\\=([^&]*))?)?.*$",
        "i"
      ),
      "$1"
    )
  );

export const displayDate = (startDate, endDate) => {
  let isSameYear = startDate.format("YY") == endDate.format("YY");
  let isSameMonth = startDate.format("M") == endDate.format("M");

  if (isSameMonth) {
    if (isSameYear) {
      return startDate.format("D") + " - " + endDate.format("D MMM");
    } else {
      return startDate.format("D MMM") + " - " + endDate.format("D MMM");
    }
  }

  if (isSameYear) {
    return startDate.format("D MMM") + " - " + endDate.format("D MMM");
  } else {
    return startDate.format("D MMM") + " - " + endDate.format("D MMM");
  }
};

export const fullDisplayDate = (startDate, endDate) => {
  if (startDate && endDate) {
    const next = moment(endDate, "YYYY-MM-DD");
    const current = moment(startDate, "YYYY-MM-DD");

    if (next.format("Y") === current.format("Y")) {
      return `${current.format("MMM D")} - ${next.format("MMM D, Y")}`;
    } else {
      return `${current.format("MMM D, Y")} - ${next.format("MMM D, Y")}`;
    }
  } else if (startDate && !endDate) {
    const current = moment(startDate, "YYYY-MM-DD");
    return current.format("MMM D, Y");
  } else {
    return "";
  }
};

export const getCloudinaryUrl = (
  originalImage,
  config = {},
  enabled = true
) => {
  if (window.location.origin.endsWith(".local")) {
    return originalImage;
  }

  const domain = new URL(originalImage).origin;
  if (
    !enabled ||
    (!domain.endsWith("zubludiving.com") && !domain.endsWith("zublu.com"))
  ) {
    return originalImage;
  }

  if (originalImage.endsWith(".webp")) {
    return originalImage;
  }

  let otherTransformations = [];
  const { width } = config;

  if (width) {
    otherTransformations.push(`w_${width}`);
  }

  if (otherTransformations.length) {
    return `https://res.cloudinary.com/zublu/image/fetch/f_auto,${otherTransformations.join(
      ","
    )}/${originalImage}`;
  }

  return `https://res.cloudinary.com/zublu/image/fetch/f_auto/${originalImage}`;
};

export const formatPrice = (price) => {
  return price.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
};

export const convertPrice = (code, price) => {
  if (typeof price === "string" && price.includes(",")) {
    price = price.replaceAll(",", "");
  }

  if (window.zubluCurrencyTable[code]) {
    const value = Math.floor(price / window.zubluCurrencyTable[code]);
    if (value >= 1000000) {
      const length = value.toString().length;
      const abbreviateNumber = value.toString().slice(0, length - 3);
      return `${formatPrice(Number(abbreviateNumber))}k`;
    }

    return formatPrice(value);
  }
  return formatPrice(price);
};

export const getSelectedCurrency = () => {
  let selectedCurrency = CURRENCIES[7];
  const currencyType = localStorage.getItem("CurrencyType");
  if (!!currencyType) {
    selectedCurrency = JSON.parse(localStorage.getItem("CurrencyType"));
  }

  return selectedCurrency;
};

export const totalDays = (from, to, night = false) => {
  const next = moment(to, "YYYY-MM-DD");
  const current = moment(from, "YYYY-MM-DD");
  const diffs = next.diff(current, "days");
  return night ? diffs : diffs + 1;
};

export const tryParse = (data, fallback) => {
  try {
    return JSON.parse(data);
  } catch (e) {
    return fallback;
  }
};
